export function computeBidders(slot: googletag.Slot): pbjs.Bid.Bidder[] {
  const searchParameters = new URLSearchParams(window.location.search);
  const isPrebidDebugMode = searchParameters.has("pbjs_debug");

  const debugBidders: Set<pbjs.Bid.Bidder["bidder"]> = isPrebidDebugMode
    ? new Set(
        (searchParameters.get("pbjs_debug_bidders")?.split(",") as pbjs.Bid.Bidder["bidder"][]) ?? [
          "appnexus" as const,
          "spotx" as const,
        ],
      )
    : new Set();

  return [
    createSpotXBidder(),
    createAppNexusBidder(),
    {
      bidder: "unruly",
      params: {
        siteId: 211_342,
      },
    },
    {
      bidder: "teads",
      params: {
        pageId: 109_129,
        placementId: 118_631,
      },
    },
    {
      bidder: "rubicon",
      params: {
        accountId: 16_912,
        siteId: 159_838,
        video: {},
        zoneId: 766_520,
      },
    },
    {
      bidder: "rubicon",
      params: {
        accountId: 16_912,
        siteId: 159_836,
        video: {},
        zoneId: 766_516,
      },
    },
    {
      bidder: "triplelift",
      params: {
        inventoryCode: "scmp_outstream_article",
      },
    },
  ];

  function createAppNexusBidder(): pbjs.Bid.AppNexus {
    return {
      bidder: "appnexus",
      params: {
        placementId: debugBidders.has("appnexus") ? 13_232_385 : 17_066_625,
      },
      renderer: {
        options: {
          disableCollapse: {
            enabled: true,
          },
          endCard: {
            enabled: true,
          },
        },
      },
    };
  }

  function createSpotXBidder(): pbjs.Bid.SpotX {
    return {
      bidder: "spotx",
      params: {
        ad_unit: "outstream",
        channel_id: debugBidders.has("spotx") ? "85394" : "288505",
        outstream_options: {
          custom_override: {
            click_to_replay: "1",
            collapse: "0",
          },
          slot: slot.getSlotElementId(),
        },
      },
    };
  }
}
